import { render, staticRenderFns } from "./CourseNavigation.vue?vue&type=template&id=180ffc15&"
import script from "./CourseNavigation.vue?vue&type=script&lang=js&"
export * from "./CourseNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports